import React, { useState, useEffect, useContext } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import GraphQL from '../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import SmartTable from '../../shared/components/material-table';
import columns from './components/Columns';
import SelectorCourseSeriesModal from './components/SelectorCourseSeriesModal';
import SmartContext from '../App/context/SmartContext';
import listCoursesWithStepsByFilter from '../../shared/queries/Course';
import {
  cycleEndingSaveMutation,
  findAllCycleEnding,
} from '../../shared/queries/ConsolidationCycleClosing';
import { ACTION_NAME } from '../../shared/utils/constants';

const ReportCard = (props) => {
  const [data, setData] = useState([]);
  const { t, history, dispatch } = props;
  const [selectionCourseModal, setSelectionCourseModal] = useState(false);
  const [coursesWithSteps, setCoursesWithSteps] = useState([]);
  const context = useContext(SmartContext);
  const { loggedUser } = context;

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadAllCycleEnding = () => {
    showLoading();
    const query = findAllCycleEnding();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.findAllCycleEnding = res.findAllCycleEnding.map((cycleEnding) => ({
          ...cycleEnding,
          status: cycleEnding.cycleClosed ? t('general.F') : t('general.A'),
        }));
        setData([...res.findAllCycleEnding]);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const toggleSelectionCourse = () => {
    setSelectionCourseModal(!selectionCourseModal);
  };

  const openModalForm = () => {
    showLoading();
    const filter = { id: 0 };
    const query = listCoursesWithStepsByFilter(filter);
    GraphQL(query, {})
      .then(({ courseListByFilter }) => {
        hideLoading();
        setCoursesWithSteps(courseListByFilter);
        toggleSelectionCourse();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/fechamento-ciclo/mnt/${rowData.id}`);
  };

  const addItemClickHandler = (formValues) => {
    const mutation = cycleEndingSaveMutation(formValues);
    GraphQL(mutation, {})
      .then((res) => {
        history.push(`/minime/fechamento-ciclo/mnt/${res.cycleEndingSave.id}`);
      })
      .catch(() => {});
    toggleSelectionCourse();
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find(
        (a) => a.name === ACTION_NAME.VIEW_VISUALIZATION
      ).hidden = !propss.data.cycleClosed;
      copyProps.actions.find((a) => a.name === ACTION_NAME.EDIT).hidden =
        propss.data.cycleClosed;
    }
  };

  useEffect(() => {
    loadAllCycleEnding();
  }, []);

  return (
    <Container>
      {selectionCourseModal && (
        <SelectorCourseSeriesModal
          isOpen={selectionCourseModal}
          toggle={toggleSelectionCourse}
          onSelection={addItemClickHandler}
          schoolTerm={{
            id: loggedUser.selectedTermId,
            name: loggedUser.selectedTermName,
          }}
          data={coursesWithSteps}
          dispatch={dispatch}
          cyclesClosure={data}
        />
      )}
      <Row className="Table">
        <Col md={12} lg={12}>
          <Card>
            <CardBody className="material-table-card">
              <div className="material-table__wrap">
                <SmartTable
                  data={data}
                  columns={columns(t)}
                  pageSize={20}
                  onAddClick={openModalForm}
                  onRefreshClick={loadAllCycleEnding}
                  onEditClick={editItemClickHandler}
                  title={t('panels.cycle-closing')}
                  actionsDisabled
                  actionsDisabledByConditional={actionsDisabledByConditional}
                  onViewVisualizationClick={{
                    tooltip: t('general.tables.view-visualization'),
                    callback: editItemClickHandler,
                  }}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

ReportCard.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ReportCard)
);
